module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_8019.e54b2901.png";